const popup = document.getElementById('ContactPopup');
if (popup) {
  const formWrapper = popup.querySelector('.contact-popup__form-wrapper');
  const successEl = popup.querySelector('.contact-popup__success');
  const form = popup.querySelector('form');
  const scrollContainer = popup.querySelector('.contact-popup__scroll');

  const openPopup = () => {
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('contact-popup-open');
  };

  const closePopup = () => {
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('contact-popup-open');
  };

  const resetPopup = () => {
    successEl.style.display = 'none';
    formWrapper.style.display = '';
    if (form) form.reset();
    form.removeAttribute('target');
    const iframe = document.getElementById('contact-popup-iframe');
    if (iframe) iframe.remove();
    scrollContainer.scrollTop = 0;
  };

  const showSuccess = () => {
    formWrapper.style.display = 'none';
    successEl.style.display = '';
    scrollContainer.scrollTop = 0;
  };

  const isPopupLink = (link) => {
    if (!link) return false;

    try {
      return new URL(link.href, window.location.href).hash === '#contact-popup';
    } catch (error) {
      return false;
    }
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (isPopupLink(link)) {
      e.preventDefault();
      openPopup();
    }
  });

  if (window.location.hash === '#contact-popup') {
    openPopup();
  }

  popup.querySelectorAll('[data-contact-popup-close]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
      setTimeout(resetPopup, 300);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
      setTimeout(resetPopup, 300);
    }
  });

  if (form) {
    form.addEventListener('submit', () => {
      const submitBtn = form.querySelector('.contact-form-section__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      let iframe = document.getElementById('contact-popup-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'contact-popup-iframe';
        iframe.name = 'contact-popup-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      form.target = 'contact-popup-iframe';

      iframe.onload = () => {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send';
        showSuccess();
      };
    });
  }
}
